module.exports = __webpack_public_path__ + "static/media/Guided Surgery_3.886ce807.png";